import { render, staticRenderFns } from "./SelectGroup.vue?vue&type=template&id=8fae3f10&lang=pug"
import script from "./SelectGroup.vue?vue&type=script&lang=js"
export * from "./SelectGroup.vue?vue&type=script&lang=js"
import style0 from "./SelectGroup.vue?vue&type=style&index=0&id=8fae3f10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports